import { render, staticRenderFns } from "./DiseaseDetail.vue?vue&type=template&id=50c682c9&scoped=true"
import script from "./DiseaseDetail.vue?vue&type=script&lang=js"
export * from "./DiseaseDetail.vue?vue&type=script&lang=js"
import style0 from "./DiseaseDetail.vue?vue&type=style&index=0&id=50c682c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.36.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c682c9",
  null
  
)

export default component.exports